function initFluxynaraHelp(root) {
  if (!root || root.dataset.helpInitialized === "true") return;
  root.dataset.helpInitialized = "true";

  const search = root.querySelector("[data-help-search]");
  const clear = root.querySelector("[data-help-clear]");
  const searchWrap = search?.closest(".help-search");
  const filters = root.querySelector("[data-help-filters]");
  const cards = Array.from(root.querySelectorAll("[data-help-card]"));
  const count = root.querySelector("[data-help-count]");
  const empty = root.querySelector("[data-help-empty]");
  let activeCategory = "all";

  const normalize = (value) => String(value || "").trim().toLocaleLowerCase();
  const categories = [...new Set(cards.map((card) => card.dataset.category).filter(Boolean))];

  function createFilter(label, value) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = `help-filter${value === "all" ? " is-active" : ""}`;
    button.textContent = label;
    button.dataset.category = value;
    button.setAttribute("aria-pressed", String(value === "all"));
    button.addEventListener("click", () => {
      activeCategory = value;
      filters?.querySelectorAll(".help-filter").forEach((item) => {
        const selected = item === button;
        item.classList.toggle("is-active", selected);
        item.setAttribute("aria-pressed", String(selected));
      });
      updateResults();
    });
    return button;
  }

  function updateResults() {
    const query = normalize(search?.value);
    const terms = query.split(/\s+/).filter(Boolean);
    let visible = 0;

    cards.forEach((card) => {
      const cardText = normalize(card.dataset.search);
      const categoryMatch = activeCategory === "all" || card.dataset.category === activeCategory;
      const searchMatch = terms.every((term) => cardText.includes(term));
      const show = categoryMatch && searchMatch;
      card.hidden = !show;
      if (show) visible += 1;
    });

    searchWrap?.classList.toggle("has-value", Boolean(query));
    if (count) count.textContent = `${visible} ${visible === 1 ? "guide" : "guides"}`;
    if (empty) empty.hidden = visible !== 0;
  }

  if (filters && cards.length) {
    filters.append(createFilter("All products", "all"));
    categories.forEach((category) => filters.append(createFilter(category, category)));
  }

  search?.addEventListener("input", updateResults);
  clear?.addEventListener("click", () => {
    if (!search) return;
    search.value = "";
    search.focus();
    updateResults();
  });

  root.querySelectorAll("[data-copy-guide-link]").forEach((button) => {
    button.addEventListener("click", async () => {
      const card = button.closest("[data-help-card]");
      if (!card?.id) return;
      const url = new URL(window.location.href);
      url.search = "";
      url.hash = card.id;

      try {
        await navigator.clipboard.writeText(url.toString());
        const original = button.textContent;
        button.textContent = "Link copied";
        window.setTimeout(() => { button.textContent = original; }, 1800);
      } catch (_error) {
        window.location.hash = card.id;
      }
    });
  });

  const hashCard = window.location.hash ? root.querySelector(window.location.hash) : null;
  if (hashCard?.matches("[data-help-card]")) {
    hashCard.querySelector("[data-help-details]")?.setAttribute("open", "");
  }

  updateResults();
}

document.querySelectorAll("[data-help-root]").forEach(initFluxynaraHelp);

if (!window.fluxynaraHelpEditorEventsBound) {
  window.fluxynaraHelpEditorEventsBound = true;

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll?.("[data-help-root]").forEach(initFluxynaraHelp);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const card = event.target.closest?.("[data-help-card]");
    card?.querySelector("[data-help-details]")?.setAttribute("open", "");
  });
}
